module.exports = __webpack_public_path__ + "static/media/wifi@2x.31ffd7d8.png";